import React from "react";
import TopBarLogo from '../Shared/TopBarLogo';

export default function InicioContent() {
  return (
    <div>
        <TopBarLogo />
        <div className="info-box">
        <h2>Vista de inicio</h2>
        <p>
            Recuerda que en <strong>Mercanteomexico.com</strong> solo puedes visualizar tus datos e información.
            Para realizar cambios, utiliza nuestra <strong>app móvil</strong>.
        </p>
        <p className="mensaje-aviso">
            🙏 Disculpa por las molestias, estamos trabajando para que estas opciones estén disponibles muy pronto también desde la web.
        </p>
        
        </div>
    </div>
  );
} 
